import { PaginatedSearchableRepository } from "mobx-repository";
import type { PageInfo } from "../api";
import { defaultPageSize } from "./constants";
import type { IdProvider } from "./uuid";

export interface ApiResource {
    query: unknown;
    entity: IdProvider;
    create: unknown;
    update: unknown;
    sortKey: string;
}

export abstract class ElofleetRepository<
    Resource extends ApiResource = ApiResource,
    TId = string,
    TBatchId = string,
> extends PaginatedSearchableRepository<Resource["query"], Resource["entity"], TId, TBatchId> {
    // Used to obtain the type of ApiResource used with this repository.
    // Do not use for runtime code.
    readonly apiResource!: Resource;

    protected defaultCount = defaultPageSize;

    public abstract fetchMetadata(query: Resource["query"]): Promise<PageInfo>;

    public abstract update(id: TId, update: Resource["update"]): Promise<Resource["entity"]>;

    public abstract create(update: Resource["create"]): Promise<Resource["entity"]>;

    public abstract delete(...ids: TId[]): Promise<void>;
}
